module.exports = __webpack_public_path__ + "img/menu.d4b7cbf4.svg";